import { useState } from "react";
import { motion } from "framer-motion";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

import p1 from "../assets/photo_1_2026-03-22_20-48-30.jpg";
import p2 from "../assets/photo_2_2026-03-22_20-48-30.jpg";
import p3 from "../assets/photo_3_2026-03-22_20-48-30.jpg";
import p4 from "../assets/photo_4_2026-03-22_20-48-30.jpg";
import p5 from "../assets/photo_5_2026-03-22_20-48-30.jpg";
import p6 from "../assets/photo_6_2026-03-22_20-48-30.jpg";
import p7 from "../assets/photo_7_2026-03-22_20-48-30.jpg";
import p8 from "../assets/photo_8_2026-03-22_20-48-30.jpg";
import p9 from "../assets/photo_9_2026-03-22_20-48-30.jpg";
import p10 from "../assets/photo_10_2026-03-22_20-48-30.jpg";
import p11 from "../assets/photo_11_2026-03-22_20-48-30.jpg";

import a1 from "../assets/photo_1_2026-04-26_14-11-50.jpg";
import a2 from "../assets/photo_2_2026-04-26_14-11-50.jpg";
import a3 from "../assets/photo_3_2026-04-26_14-11-50.jpg";
import a4 from "../assets/photo_4_2026-04-26_14-11-50.jpg";
import a5 from "../assets/photo_5_2026-04-26_14-11-50.jpg";
import a6 from "../assets/photo_6_2026-04-26_14-11-50.jpg";
import a7 from "../assets/photo_7_2026-04-26_14-11-50.jpg";

import vid0 from "../assets/IMG_7650.mp4";
import vid1 from "../assets/IMG_1353.MP4";
import vid2 from "../assets/IMG_1354.MP4";
import vid3 from "../assets/IMG_1355.MP4";
import vid4 from "../assets/IMG_1356.MP4";

const photos = [
  a5, a2, a3, p8, a1, a4,
  a6, a7, p9, p10,
  p7, p6, p1, p3,
  p2, p4, p11, p5,
];

const videos = [vid0, vid1, vid2, vid3, vid4];

const slides = photos.map((src) => ({ src }));

const containerVariants = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.05 } },
};

const itemVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.4 } },
};

export const Gallery = () => {
  const [open, setOpen] = useState(false);
  const [index, setIndex] = useState(0);

  const openAt = (i) => {
    setIndex(i);
    setOpen(true);
  };

  return (
    <section
      datatype="gallery"
      id="gallery"
      className="s-gallery-type-9 sb-text-dark sb-padding-top_l sb-padding-bottom_l"
    >
      <div className="sb-background" style={{ background: "#fff" }}></div>
      <div className="sb-container sb-m-clear-bottom">
        <motion.div
          initial={{ opacity: 0, transform: "translate3d(0, 60px, 0)" }}
          whileInView={{ opacity: 1, transform: "translate3d(0, 0, 0)" }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="sb-row sb-m-5-bottom sb-m-clear-bottom"
        >
          <h2 className="sb-col_lg-10 sb-col_md-12 sb-col_sm-12 sb-col_xs-12 sb-m-12-bottom sb-font-h2 sb-font-title">
            Галерея
          </h2>
        </motion.div>

        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.05 }}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4, 1fr)",
            gap: "12px",
            marginTop: "32px",
          }}
          className="gallery-grid"
        >
          {photos.map((src, i) => (
            <motion.div
              key={`p-${i}`}
              variants={itemVariants}
              onClick={() => openAt(i)}
              style={{
                cursor: "pointer",
                overflow: "hidden",
                borderRadius: "10px",
                aspectRatio: "1 / 1",
                position: "relative",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
              }}
              className="gallery-thumb"
            >
              <img
                src={src}
                alt={`Студия массажа Александра Стрельцова — фото ${i + 1}`}
                loading="lazy"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                  transition: "transform 0.4s ease",
                }}
              />
            </motion.div>
          ))}
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="sb-m-12-top"
          style={{ marginTop: "48px" }}
        >
          <h3
            className="sb-font-h4 sb-font-title"
            style={{ marginBottom: "20px" }}
          >
            Видео
          </h3>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(3, 1fr)",
              gap: "12px",
            }}
            className="gallery-videos"
          >
            {videos.map((src, i) => (
              <div
                key={`v-${i}`}
                style={{
                  borderRadius: "10px",
                  overflow: "hidden",
                  aspectRatio: "16 / 11",
                  background: "#000",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                }}
              >
                <video
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    display: "block",
                  }}
                  controls
                  preload="metadata"
                  playsInline
                >
                  <source src={src} type="video/mp4" />
                </video>
              </div>
            ))}
          </div>
        </motion.div>
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={slides}
        index={index}
        styles={{
          container: { backgroundColor: "rgba(0,0,0,0.94)" },
        }}
      />

      <style>{`
        @media (max-width: 991px) {
          .gallery-grid {
            grid-template-columns: repeat(3, 1fr) !important;
          }
          .gallery-videos {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 639px) {
          .gallery-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 8px !important;
          }
          .gallery-videos {
            grid-template-columns: 1fr !important;
          }
        }
        .gallery-thumb:hover img {
          transform: scale(1.07);
        }
      `}</style>
    </section>
  );
};
